import cn from 'classnames';
import { LayoutContainer, Picture } from '@petsmart-ui/sparky';
import { ContentfulClick } from '@libs/analytics';
import { HeaderCtaTracker } from '../../../utils/HeaderCtaTracker';
import { getImageProps } from '../../../utils/propsImagesItems';
import type { CampaignCarsUpProps } from '../types';
import { colorMap } from '../utils';
import { Text } from '../../Text';
import './4up.scss';

export function CampaignCards4up({
    header,
    body,
    cards,
    textLink,
    textLinkColor,
    textColor,
    backgroundFill,
    cardsTextColor,
}: CampaignCarsUpProps) {
    return (
        <LayoutContainer className="campaign-cards-4up">
            <div className="campaign-cards-4up__content" style={{ background: backgroundFill }}>
                <div className="campaign-cards-4up__header">
                    <Text color={textColor} as="h2">
                        {header}
                    </Text>

                    <Text align="center" color={textColor}>
                        {body}
                    </Text>

                    {textLink && (
                        <HeaderCtaTracker
                            textLink={textLink}
                            linkTextColor={textLinkColor}
                            header={header ?? ''}
                            promoVariant="campaign cards up - 4up"
                            promoType="campaign-cards-4up__card"
                        />
                    )}
                </div>

                <div className="campaign-cards-4up__cards">
                    {cards.slice(0, 4).map((c, index) => {
                        const cm = colorMap[cardsTextColor];
                        const linkUrl = c?.link?.webUrl || textLink?.link?.webUrl || '';
                        const Component = linkUrl ? 'a' : 'div';

                        return (
                            <ContentfulClick
                                component={Component}
                                key={c.sysId}
                                className="campaign-cards-4up__card"
                                style={{ background: c.backgroundFill }}
                                href={linkUrl}
                                eventData={{
                                    position: index + 1,
                                    linkText: cn(c.preheader, c.header, c.subheader, c.body),
                                    linkUrl,
                                    promoTitle: header ?? '',
                                    promoVariant: 'campaign cards up - 4up',
                                    promoDesc: c.internalTitle,
                                    promoType: 'campaign-cards-4up__card',
                                }}
                            >
                                <div className="campaign-cards-4up__card-content">
                                    <Text color={cm?.preheaderColor} className="campaign-cards-4up__card-preheader">
                                        {c.preheader}
                                    </Text>
                                    <div className="campaign-cards-4up__card-heading-raw">
                                        <Text as="h2" color={cm?.headingColor}>
                                            {c.header}
                                        </Text>
                                        <Text color={cm?.subheaderColor} className="campaign-cards-4up__card-subheader">
                                            {c.subheader}
                                        </Text>
                                    </div>
                                    <Text color={cm?.textColor} className="campaign-cards-4up__card-body">
                                        {c.body}
                                    </Text>
                                    <Text color={cm?.textColor} className="campaign-cards-4up__card-terms">
                                        {c.terms}
                                    </Text>
                                </div>

                                <Picture {...getImageProps(c.image)} />
                            </ContentfulClick>
                        );
                    })}
                </div>
            </div>
        </LayoutContainer>
    );
}
